import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{ padding: 24, textAlign: 'center' }}>
          <h3>Algo salió mal</h3>
          <p style={{ color: '#666', fontSize: 14 }}>Error inesperado. Intenta recargar la página.</p>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: 12, padding: '8px 24px', borderRadius: 8, border: 'none', background: 'var(--bry-accent)', color: 'var(--bry-text-main)', cursor: 'pointer' }}
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
